export default __webpack_public_path__ + "static/maarten-7b6b3f97f65f832caad5ae4c7682e0d9.jpg";